import React, { useEffect, useState } from "react";
import UsersList from "../../../../components/UserManagementComponents/Users/UsersList";
import { ReactComponent as NoDataImage } from "./assets/noDataImage.svg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  requestTeamUsersList,
  setTeamUsersList,
} from "../../../../store/slices/teams";
import { getTeamUsers } from "../../../../store/selectors/teams";
import { EmptyPage } from "../../../../components/EmptyPage";
import { PlusLg } from "react-bootstrap-icons";

type Props = {};

const TeamsById: React.FC<Props> = (props) => {
  const { id } = useParams();
  const users = useSelector(getTeamUsers);
  const dispatch = useDispatch();
  const [usersCount, setUsersCount] = useState(0);

  useEffect(() => {
    if (!users?.length) {
      dispatch(
        requestTeamUsersList({
          id: id as string,
          limit: 20,
          callbacks: {
            onSuccess: (data) => {
              setUsersCount(data?.count || 0);
            },
          },
        })
      );
    }
    return () => {
      dispatch(setTeamUsersList([]));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!users?.length ? (
        <EmptyPage
          Icon={NoDataImage}
          title="No users were discovered"
          subTitle={`Feel free to invite new people into your space by clicking the "Invite People" button below! `}
          button={{
            name: "Invite People",
            onClick: () => {},
            icon: <PlusLg />,
          }}
        />
      ) : (
        <>
          <UsersList users={users} isTeamTable usersCount={usersCount} />
        </>
      )}
    </>
  );
};

export default TeamsById;
